import stringSanitizer from "stringSanitizer";

 function searchParamsStringify(searchParams) {
  let searchPath = '';

  const paramsMapInCorrectOrder = {
    specialism: null,
    city: 'q',
    region: "r",
    postcode: "postcode",
    distance: "d",
    type: "gv",
    page: "page"
  };

  function getPrefixed(paramName) {
    let prefix = paramsMapInCorrectOrder[paramName];
    if (prefix) {
      return prefix + '-' + stringSanitizer(searchParams[paramName].toString().toLowerCase()) + '/';
    }
    return stringSanitizer(searchParams[paramName]) + '/';
  }

  for (let paramName in paramsMapInCorrectOrder) {
    if (searchParams[paramName]) {
      searchPath += getPrefixed(paramName);
    }
  }
  return searchPath;
}

export default searchParamsStringify;